export default __webpack_public_path__ + "static/media/je.937a06a7.svg";